module.exports = __webpack_public_path__ + "static/news5pic3-9974f047072f8bbf086340c82614ef64.jpg";